module.exports = __webpack_public_path__ + "static/media/ch.14039616.svg";